<!--
 * @Author: chenlin
 * @Date: 2019-08-23 15:46:07
 * @LastEditors: lzq
 * @LastEditTime: 2023-10-30 17:44:51
 * @Description: 在此添加描述
 -->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted(){
    console.log(this.$routers);
  }
}
</script>



<style>
@import "../public/css/x-table.css";
@import "../public/css/iconfont.css";
@import "../public/css/blui_pc.css";
@import "../public/css/blvue_pc.css";
@import "../public/css/custom_pc.css";
@import "../public/css/udi.css";

#nprogress .bar {
  background: #666 !important;
}
</style>
